import { createAction, props } from "@ngrx/store";
import { CdrFilter, CdrRequest } from "../models/cdr.model";
import { CdrFilterParameters, CdrItemCdrSummaryResponsePagedResponseWithMetadata, ErrorModel } from "../../../core/cms-api/models";

export const loadCdrList = createAction('[CDR] Load cdr list', props<{cdrRequest: CdrRequest}>());
export const loadCdrListSuccess = createAction('[CDR] Load cdr list success', props<{cdrResponse: CdrItemCdrSummaryResponsePagedResponseWithMetadata}>());
export const loadCdrListFailure = createAction('[CDR] Load cdr list failure', props<{error: ErrorModel}>())

export const changeCdrPagination = createAction('[CDR] Cdr pagination change', props<{ pageIndex: number, pageSize: number }>());
export const changeCdrPaginationSuccess = createAction('[CDR] Cdr pagination changed successful');

export const changeCdrRequest = createAction('[CDR] Change cdr request', props<{cdrRequest: CdrRequest}>());
export const changeCdrRequestSuccess = createAction('[CDR] Cdr request changed successful');

export const loadCdrFilterParameters = createAction('[CDR] Load filter parameters', props<{cdrRequest: CdrRequest}>());
export const loadCdrFilterParametersSuccess = createAction('[CDR] Load filter perameters success', props<{cdrFilters: CdrFilterParameters}>());
export const loadCdrFilterParametersFailure = createAction('[CDR] Load filter parameters failure', props<{error: ErrorModel}>());

export const changeCdrFilter = createAction('[CDR] Change cdr filter', props<{cdrFilter: CdrFilter}>());
export const changeCdrFilterSuccess = createAction('[CDR] Change cdr filter success');